import React from 'react';
import {Visibility} from '@material-ui/icons';

export const VisibilityOnIcon = () => {
  return <Visibility />;
};
